<template>
  <div class="ff-item">
    <div class="ff-item-inner">
      <div class="ff-img" :style="{'background-image': 'url('+ imgSrc + ')'}"></div>
      <slot name="mark"></slot>
    </div>
    <p v-if="name" v-marquee class="ff-item-name"><span>{{name}}</span></p>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: String,
    name: String
  }
}
</script>

<style lang="scss" scoped>
.ff-item {
  @include flexrc;
  flex-direction: column;
  @include px2res(width, 134);
  overflow: hidden;
  .ff-item-inner {
    @include flexrc;
    @include px2res(width, 134);
    @include px2res(height, 134);
    position: relative;
    .ff-img {
      @include px2res(width, 100);
      @include px2res(height, 100);
      background-size: contain;
    }
  }
  .ff-item-name {
    width: 100%;
    text-align: center;
    @include px2res(font-size, 24);
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Item.vue